<div class="section-header">
  <h2 class="section-header__title truncate" [title]="sectionTitle()">{{ sectionTitle() }}</h2>

  <mat-divider class="section-header__line-filler" />
</div>

<ng-content />
